import { BottomSheetIllustrationContent } from "@clipboard-health/ui-components";
import { getSafeAreaPaddings, getTheme } from "@clipboard-health/ui-theme";
import { Stack, ThemeProvider } from "@mui/material";
import { openBrowser } from "@src/appV2/lib";
import { APP_V2_APP_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { Button } from "@src/appV2/redesign/components/Button";
import { IconButton } from "@src/appV2/redesign/components/IconButton";
import { PageFooterWrapper } from "@src/appV2/redesign/components/PageFooterWrapper";
import { PageHeaderTopRow } from "@src/appV2/redesign/components/PageHeaderTopRow";
import { PageWrapper } from "@src/appV2/redesign/components/PageWrapper";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { useHistory } from "react-router-dom";

import { TabRouterPath } from "../routing/constant/tabRoute";

export function SavingsBookCallPage() {
  const worker = useDefinedWorker();
  const history = useHistory();

  const handleBookCall = async () => {
    await openBrowser("https://calendly.com/d/cwg5-sbv-3kt/clipboard-savings");

    logEvent(APP_V2_APP_EVENTS.SAVINGS_CONFIGURATION_BOOK_CALL_CLICKED, {
      workerId: worker.userId,
    });
  };

  return (
    <ThemeProvider theme={getTheme()}>
      <PageWrapper variant="tertiary">
        <PageHeaderTopRow
          hideBackButton
          rightAction={
            <IconButton
              iconType="close"
              size="large"
              variant="outlined"
              onClick={() => history.replace(TabRouterPath.ACCOUNT)}
            />
          }
          title="Book a call"
          fallbackGoBackPath={TabRouterPath.ACCOUNT}
          sx={(theme) => ({ ...getSafeAreaPaddings({ top: true, fallbackTop: theme.spacing(5) }) })}
        />

        <BottomSheetIllustrationContent
          illustrationType="phone"
          title="Sign up today"
          description="Thank you for outlining your savings goal. Book a call with a member of our team to finish setting up your Clipboard Savings!"
          hasFooter
        />
        <PageFooterWrapper>
          <Stack spacing={4}>
            <Button fullWidth variant="contained" size="large" onClick={handleBookCall}>
              Book a call
            </Button>
            <Button
              fullWidth
              variant="outlined"
              size="large"
              onClick={() => history.replace(TabRouterPath.ACCOUNT)}
            >
              Dismiss
            </Button>
          </Stack>
        </PageFooterWrapper>
      </PageWrapper>
    </ThemeProvider>
  );
}
